import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PreventAuthRoute = ({ children }) => {
  const { isAuthenticated, role } = useAuth();

  if (isAuthenticated) {
    // Redirect based on role
    switch (role) {
      case 'admin':
        return <Navigate to="/admin/dashboard" replace />;
      case 'mcc':
        return <Navigate to="/mcc/mapping" replace />;
      case 'trainer':
        return <Navigate to="/trainer/dashboard" replace />;
      case 'trainee':
        return <Navigate to="/Trainee-details" replace />;
      case 'iti':
        return <Navigate to="/iti-home" replace />;
      case 'industry':
        return <Navigate to="/industry/dashboard" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default PreventAuthRoute;


